import React, { useCallback, useEffect, useRef } from 'react';
import Fireworks from 'react-canvas-confetti/dist/presets/fireworks';

interface ConfettiCelebrationProps {
  onComplete?: () => void;
  autoComplete?: boolean;
  duration?: number;
  zIndex?: number;
}

export const ConfettiCelebration: React.FC<ConfettiCelebrationProps> = ({
  onComplete,
  autoComplete = true,
  duration = 2000,
  zIndex = 9999,
}) => {
  const conductorRef = useRef<any>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleInit = useCallback(
    ({ conductor }: { conductor: any }) => {
      conductorRef.current = conductor;

      conductor.run({
        speed: 5,
        duration: duration / 1000,
      });

      if (autoComplete) {
        timeoutRef.current = setTimeout(() => {
          onComplete?.();
        }, duration);
      }
    },
    [onComplete, autoComplete, duration]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex,
      }}
    >
      <Fireworks
        onInit={handleInit}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};
